import React from 'react';
import VehicleList from './components/VehicleList';

const VehicleListPage: React.FC = () => {
  // Title is set at the application level
  return <VehicleList />;
};

export default VehicleListPage;